// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QVRON","cards":"styles_cards__y3OOo","card":"styles_card__HgUm5"};